export default "__VITE_ASSET__BxwKZ9Nz__"